/* ════════════════════════════════════════════════════════
   Diamo — Custom Design page JS
   Vanilla ES5-compatible. No framework.
   ════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────── */
  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  function pct(v, min, max) { return ((v - min) / (max - min)) * 100; }
  function fmtDollar(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function isMobile()   { return window.matchMedia('(max-width: 720px)').matches; }
  function closestEl(node, sel) {
    while (node && node.nodeType === 1) {
      if (node.matches ? node.matches(sel) : false) return node;
      node = node.parentNode;
    }
    return null;
  }
  function getQueryParam(name) {
    var q = (window.location && window.location.search) || '';
    var re = new RegExp('[?&]' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^&]*)');
    var m = q.match(re);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }

  /* Category labels — shared by picker note + loading state */
  var CAT_LABELS = {
    engagement:    'Engagement Rings',
    wedding:       'Wedding Bands',
    'wedding-male':"Men's Bands",
    necklace:      'Necklaces',
    earrings:      'Earrings',
    bracelet:      'Bracelets',
    other:         'Starting from scratch'
  };

  /* ── State ───────────────────────────────────────────── */
  var S = {
    sessionId:    '',  // minted when a category is first picked; upsert key
    stage:        '',  // '' → in_progress → started → submitted
    startedFired: false, // guard so the "started" milestone fires once
    step:         0,   // guided: current question index (0-based)
    category:     '',
    starter:      '',
    baseDesign:   '',
    prefilled:    false, // arrived via a "Modify this design" deep link — prefill only, standard modify flow
    budgetMin:    2000,
    budgetMax:    8000,
    budgetUnsure: false,
    budgetSkipped:false,
    timeline:     'No fixed date',
    notes:        '',
    refUrl:       '',
    files:        [],   // { name, objectUrl, file, url } — not persisted (blob URLs/File objects don't survive reload)
    name:         '',
    email:        '',
    phone:        ''
  };

  /* localStorage autosave (§2) */
  var LS_KEY        = 'diamo_custom_brief';
  var LS_LEAD_KEY   = 'diamo_custom_lead_fired';
  var LS_MSG_KEY    = 'diamo_custom_brief_msg';  /* survives clearBrief — read once on the success screen */

  /* ── DOM refs (populated in init) ───────────────────── */
  var D = {};

  /* ════════════════════════════════════════════════════════
     INIT
     ════════════════════════════════════════════════════════ */
  function init() {
    var page = qs('.cd-page');
    if (!page) return;

    /* Cache DOM refs */
    D.page         = page;
    D.formSec      = qs('.cd-form-sec', page);
    D.guidedWrap   = qs('.cd-guided', page);
    D.singleWrap   = qs('.cd-single-wrap', page);
    D.steps        = qsa('[data-cd-step]', page);
    D.progressFill = qs('.cd-progress__fill', page);
    D.btnBack      = qs('[data-cd-back]', page);
    D.btnSkip      = qs('[data-cd-skip]', page);
    D.btnNext      = qs('[data-cd-next]', page);
    D.contactForm  = qs('#cd-contact-form', page);
    D.hiddenBody   = qs('#cd-compiled-body', page);

    /* Detect post-success signal */
    var signal = qs('#cd-form-success', page);
    if (signal) {
      clearBrief();  /* brief submitted — discard the saved draft */
      showSuccessState(signal.getAttribute('data-name') || '');
      return;
    }

    /* Initialize interactive sections */
    initHeroCtas();
    initHeroImageScroll();
    initGuidedForm();
    initCategoryCards();
    initStarterCards();
    initBudgetSlider();
    initTimelinePills();
    initDropzone();
    initContactFields();
    initSinglePageSidebar();
    initDesignPickerActual();
    initPickerSearch();
    initProcessTimeline();
    initGallery();
    initFAQ();
    initFormSubmit();
    initWhatsAppChatButtons();

    /* Restore any autosaved brief (§2) — runs last so all UI is wired */
    restoreBrief();

    /* A product's "Modify this design" deep-link overrides the restored draft:
       prefill category/starter/design, then open on the first unanswered step
       of the standard modify flow. */
    initModifyPreset();

    /* Best-effort final snapshot when the tab is hidden or closed, so a dying
       session still lands its latest state in the Sheet. */
    initPageHide();
  }

  /* Prefill the modify flow from ?base=<handle>&design=<title>&category=<id>
     (set by the product page's "Modify this design" button). Guided layout only.
     This only prefills answers — it uses the standard modify flow, not a
     dedicated order. */
  function initModifyPreset() {
    if (!D.guidedWrap) return;
    var base = getQueryParam('base');
    if (!base) return;

    S.starter    = 'modify';
    S.baseDesign = getQueryParam('design') || base;
    S.prefilled  = true;
    var cat = getQueryParam('category');
    if (cat) S.category = cat;

    /* Reflect the prefilled answers in the UI so stepping Back from references
       shows the category, starter and design as already chosen (mirrors what
       restoreBrief does for a saved draft). */
    if (S.category) {
      qsa('[data-cat-id]', D.page).forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-cat-id') === S.category);
      });
      updatePickerForCategory(S.category);
      updateStarterAvailability(S.category);
    }
    qsa('[data-starter-id]', D.page).forEach(function (b) {
      b.classList.toggle('is-selected', b.getAttribute('data-starter-id') === S.starter);
    });
    qsa('.cd-picker-wrap', D.page).forEach(function (el) { el.classList.add('is-visible'); });
    reapplyBaseDesignSelection();

    ensureSession();          /* high-intent arrival — start the lead record */
    updateSingleSummary();
    /* Open on the first step the arrival hasn't answered. With category +
       starter + design prefilled, that lands on refs — the question this
       arrival is primed to answer. */
    S.step = firstUnansweredStep();
    renderStep();
    scrollToForm();
  }

  function initPageHide() {
    function flush() { if (S.sessionId) sendEvent('progress'); }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush();
    });
    window.addEventListener('pagehide', flush);
  }

  /* ════════════════════════════════════════════════════════
     HERO CTAs (§3) — scroll to the form
     ════════════════════════════════════════════════════════ */
  function initHeroCtas() {
    qsa('[data-cd-scroll-to-form]', D.page).forEach(function (el) {
      el.addEventListener('click', scrollToForm);
      if (el.getAttribute('role') === 'button') {
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToForm(); }
        });
      }
    });
  }

  function scrollToForm() {
    var target = qs('#brief-form', D.page) || D.formSec;
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.scrollY - 72; /* sticky-nav offset */
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* Clicking the hero image glides down to the "recent work" gallery. Only wired
     up when that section actually exists (i.e. there are gallery pieces). When
     2+ hero images are configured, the wrap also becomes an auto-rotating,
     swipeable gallery with arrows and dots — those controls own their own
     clicks (stopPropagation) and a real swipe suppresses the scroll-to-recent-
     work click that follows it, so a tap still scrolls but a drag navigates. */
  function initHeroImageScroll() {
    var wrap   = qs('.cd-hero__img-wrap', D.page);
    var target = qs('#cd-recent-work', D.page);
    if (!wrap || !target) return;
    wrap.classList.add('is-clickable');
    wrap.setAttribute('role', 'button');
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('aria-label', 'See our recent work');

    var suppressClick = false;
    function go() {
      if (suppressClick) { suppressClick = false; return; }
      var top = target.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
    wrap.addEventListener('click', go);
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
    });

    initHeroGallery(wrap, function (v) { suppressClick = v; });
  }

  /* Auto-rotate + swipe + arrows + dots for the hero gallery. No-ops with a
     single slide (or no gallery markup at all). */
  function initHeroGallery(wrap, setSuppressClick) {
    var track  = qs('[data-cd-hero-track]', wrap);
    var slides = track ? qsa('.cd-hero-gallery__slide', track) : [];
    if (!track || slides.length < 2) return;

    var dotsWrap = qs('[data-cd-hero-dots]', wrap);
    var prevBtn  = qs('[data-cd-hero-prev]', wrap);
    var nextBtn  = qs('[data-cd-hero-next]', wrap);
    var DELAY = 2000;
    var index = 0, timer = null, dots = [];

    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'cd-hero-gallery__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slides.length);
        d.addEventListener('click', function (e) { e.stopPropagation(); go(i); restart(); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    /* Each slide carries its own caption; the chip follows the visible one and
       hides itself entirely for a slide whose caption was left blank. */
    var chip    = qs('[data-cd-hero-chip]', wrap);
    var caption = qs('[data-cd-hero-caption]', wrap);

    function renderCaption() {
      if (!caption) return;
      var text = slides[index].getAttribute('data-caption') || '';
      caption.textContent = text;
      if (chip) chip.hidden = text === '';
    }

    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      renderCaption();
    }
    function go(i)   { index = (i % slides.length + slides.length) % slides.length; render(); }
    function next()  { go(index + 1); }
    function prev()  { go(index - 1); }
    function stop()  { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); timer = setInterval(next, DELAY); }
    function restart() { start(); }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); prev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); next(); restart(); });

    /* Swipe (touch). A real horizontal drag advances the slide and marks the
       click that follows touchend as consumed, so it doesn't also scroll. */
    var x0 = 0, y0 = 0;
    wrap.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; stop();
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) { next(); } else { prev(); }
        setSuppressClick(true);
      }
      restart();
    }, { passive: true });

    /* Pause on hover (desktop). */
    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', start);

    render();
    start();
  }

  /* ════════════════════════════════════════════════════════
     AUTOSAVE + LEAD CAPTURE (§2)
     ════════════════════════════════════════════════════════ */
  /* Require a 2+ char TLD so half-typed addresses ("name@host.c") don't count
     as valid and fire a lead on every keystroke. */
  function emailValid(v) { return /.+@.+\.[a-z]{2,}$/i.test((v || '').trim()); }

  function saveBrief() {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify({
        sessionId: S.sessionId, stage: S.stage, startedFired: S.startedFired,
        /* Persist the step KEY, not the index — a reorder must not resume a
           draft on the wrong question. */
        stepKey: currentStepKey(), category: S.category, starter: S.starter, baseDesign: S.baseDesign,
        budgetMin: S.budgetMin, budgetMax: S.budgetMax, budgetUnsure: S.budgetUnsure,
        budgetSkipped: S.budgetSkipped, timeline: S.timeline, notes: S.notes,
        refUrl: S.refUrl, name: S.name, email: S.email, phone: S.phone
      }));
    } catch (e) {}
  }

  function clearBrief() {
    try { localStorage.removeItem(LS_KEY); localStorage.removeItem(LS_LEAD_KEY); } catch (e) {}
  }

  /* Called on every state change: persist + schedule a progress beacon. */
  function markChanged() {
    saveBrief();
    scheduleProgress();
    updateSaveIndicator();
  }

  /* Debounce progress beacons so typing doesn't post on every keystroke.
     Only runs once a session exists (a category has been picked). */
  var progressTimer = null;
  function scheduleProgress() {
    if (!S.sessionId) return;
    if (progressTimer) clearTimeout(progressTimer);
    progressTimer = setTimeout(function () { sendEvent('progress'); }, 1500);
  }

  function updateSaveIndicator() {
    var note = qs('[data-cd-progress-note]', D.page);
    if (!note) return;
    if (emailValid(S.email)) {
      // note.textContent = '✓ Brief saved automatically';
      note.classList.add('is-saved');
    } else {
      // note.textContent = '~2 minutes · no account needed';
      note.classList.remove('is-saved');
    }
  }

  /* ── Session lifecycle ───────────────────────────────────
     The Sheet holds one evolving record per session, keyed by sessionId.
     Client stages: in_progress → started → submitted. */
  var STAGES = { in_progress: 1, started: 2, submitted: 3 };
  function stageRank(s) { return STAGES[s] || 0; }
  function advanceStage(to) { if (stageRank(to) > stageRank(S.stage)) S.stage = to; }

  function newSessionId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  /* Start a session the moment a category is picked, and create the row
     promptly (immediate progress beacon) so a fast bail is still captured. */
  function ensureSession() {
    if (S.sessionId) return;
    S.sessionId = newSessionId();
    advanceStage('in_progress');
    saveBrief();
    sendEvent('progress');
  }

  /* Milestone: the visitor advanced past the contact step, so we have a real
     lead. Fires once per session — the Telegram "started" ping (server-side)
     plus onsite analytics. */
  function fireStarted() {
    if (S.startedFired || !(S.name && emailValid(S.email))) return;
    S.startedFired = true;
    advanceStage('started');
    saveBrief();

    var payload = { event: 'custom_brief_started', name: S.name, email: S.email,
      phone: S.phone, category: S.category, starter: S.starter };
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (e) {}
    try {
      if (window._learnq) {
        window._learnq.push(['identify', { '$email': S.email, '$first_name': S.name }]);
        window._learnq.push(['track', 'Started Custom Brief', { category: S.category, starter: S.starter }]);
      }
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('diamo:custom-brief-started', { detail: payload })); } catch (e) {}

    sendEvent('started');
  }

  /* ── Server endpoint (Google Apps Script) ────────────────
     One upserted record per session — progress (silent), started and
     submitted (milestones). Fire-and-forget via sendBeacon so it survives
     the page navigation on submit. */
  function leadEndpoint() {
    var el = qs('[data-cd-endpoint]', D.page);
    var url = el ? el.getAttribute('data-cd-endpoint') : '';
    return (url || '').trim();
  }

  /* IANA zone ("America/Denver") — a rough region hint, no network call.
     Empty on the handful of browsers without Intl. */
  function browserTimezone() {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; }
    catch (e) { return ''; }
  }

  function buildPayload(eventType) {
    var uploaded = S.files.filter(function (f) { return f.url; }).map(function (f) { return f.url; });
    return {
      session_id: S.sessionId,
      event:      eventType,
      stage:      S.stage || 'in_progress',
      updated_at: new Date().toISOString(),
      name:       S.name || '',
      email:      S.email || '',
      phone:      S.phone || '',
      category:   categoryLabel(S.category) || '',
      starter:    S.starter || '',
      baseDesign: S.baseDesign || '',
      budget:     !budgetInFlow() ? 'Not specified' : (S.budgetUnsure ? 'Not sure' : (fmtDollar(S.budgetMin) + ' - ' + fmtDollar(S.budgetMax))),
      timeline:   S.timeline || '',
      refUrl:     normalizeRefUrl(S.refUrl || ''),
      notes:      (S.notes || '').trim(),
      images:     uploaded.join(', '),
      pageUrl:    (window.location && window.location.href) || '',
      timezone:   browserTimezone()
    };
  }

  function sendEvent(eventType) {
    var url = leadEndpoint();
    if (!url || !S.sessionId) return;
    var json = JSON.stringify(buildPayload(eventType));
    /* text/plain keeps sendBeacon in the CORS-safelist (no preflight) */
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([json], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(url, blob)) return;
      }
    } catch (e) {}
    try {
      fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: json });
    } catch (e) {}
  }

  /* Restore saved values + re-apply UI (§2) */
  function restoreBrief() {
    var data;
    try { data = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { data = null; }
    if (!data) return;

    /* Merge primitive fields */
    ['sessionId','stage','category','starter','baseDesign','timeline','notes','refUrl','name','email','phone'].forEach(function (k) {
      if (data[k] != null) S[k] = data[k];
    });
    if (typeof data.startedFired === 'boolean') S.startedFired = data.startedFired;
    if (typeof data.budgetMin === 'number')    S.budgetMin = data.budgetMin;
    if (typeof data.budgetMax === 'number')    S.budgetMax = data.budgetMax;
    if (typeof data.budgetUnsure === 'boolean')S.budgetUnsure = data.budgetUnsure;
    if (typeof data.budgetSkipped === 'boolean')S.budgetSkipped = data.budgetSkipped;

    /* Re-apply category selection + picker */
    if (S.category) {
      qsa('[data-cat-id]', D.page).forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-cat-id') === S.category);
      });
      updatePickerForCategory(S.category);
      updateStarterAvailability(S.category);
    }

    /* Re-apply starter selection + picker visibility */
    if (S.starter) {
      qsa('[data-starter-id]', D.page).forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-starter-id') === S.starter);
      });
      qsa('.cd-picker-wrap', D.page).forEach(function (el) {
        el.classList.toggle('is-visible', S.starter === 'modify');
      });
    }

    /* Re-apply chosen base design */
    if (S.baseDesign) {
      qsa('[data-design-id]', D.page).forEach(function (b) {
        var sel = b.getAttribute('data-design-id') === S.baseDesign;
        b.classList.toggle('is-selected', sel);
        var nameEl = qs('.cd-picker-name', b);
        if (nameEl && sel) nameEl.textContent = (b.getAttribute('data-design-name') || '') + ' ✓';
      });
    }

    /* Re-apply budget slider */
    if (D.budgetInputs) {
      if (D.budgetInputs.min) D.budgetInputs.min.value = S.budgetMin;
      if (D.budgetInputs.max) D.budgetInputs.max.value = S.budgetMax;
    }
    if (D.updateBudget) D.updateBudget();

    /* Re-apply timeline pills */
    if (S.timeline) {
      qsa('[data-timeline]', D.page).forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-timeline') === S.timeline);
      });
    }

    /* Re-apply text inputs */
    qsa('[data-cd-field]', D.page).forEach(function (el) {
      var key = el.getAttribute('data-cd-field');
      var map = { name: 'name', email: 'email', phone: 'phone', notes: 'notes', 'ref-url': 'refUrl' };
      var sKey = map[key];
      if (sKey && S[sKey]) el.value = S[sKey];
    });

    updateSingleSummary();
    updateSaveIndicator();

    /* Restore step by KEY, resolved against the current flow. Falls back to the
       first step when the key isn't in this flow — and covers legacy drafts that
       stored a numeric `step` (no key), which can't be mapped after a reorder. */
    if (D.guidedWrap) {
      var idx = data.stepKey ? currentFlow().keys.indexOf(data.stepKey) : -1;
      S.step = idx >= 0 ? idx : 0;
      renderStep();
    } else {
      refreshNav();
    }
  }

  /* ════════════════════════════════════════════════════════
     SUCCESS STATE
     ════════════════════════════════════════════════════════ */
  function showSuccessState(firstName) {
    /* Hide hero, form, section headings, process (light), price, gallery, FAQ.
       Section headings must be hidden too, or their content-less headers are
       left stranded above the success message. */
    qsa('.cd-hero-sec, .cd-form-sec, .cd-single-wrap, .cd-section-heading, .cd-process-sec--light, .cd-price-sec, .cd-gallery-sec, .cd-faq-sec', D.page).forEach(function (el) {
      el.style.display = 'none';
    });
    /* Show success section */
    var successSec = qs('.cd-success-sec', D.page);
    if (successSec) {
      successSec.style.display = '';
      /* Personalise heading */
      var nameSpan = qs('[data-cd-first-name]', successSec);
      if (nameSpan && firstName) nameSpan.textContent = ', ' + firstName;
      /* Wire the "chat now" CTA with the just-submitted brief, if we stashed it */
      wireSuccessWhatsApp(successSec);
    }
    /* Show dark process timeline */
    var darkProcess = qs('.cd-process-sec--dark', D.page);
    if (darkProcess) darkProcess.style.display = '';
  }

  /* On the post-submit page load, S is empty (fresh navigation), so read the
     brief message we stashed right before submit and build the wa.me link. */
  function wireSuccessWhatsApp(successSec) {
    var cta = qs('[data-cd-wa-cta]', successSec);
    if (!cta) return;
    var num = whatsappNumber();
    var msg = '';
    try { msg = localStorage.getItem(LS_MSG_KEY) || ''; } catch (e) {}
    try { localStorage.removeItem(LS_MSG_KEY); } catch (e) {}   /* consume once */
    if (!num) { cta.style.display = 'none'; return; }
    cta.href = whatsappUrl(msg);
    cta.style.display = '';
  }

  /* ════════════════════════════════════════════════════════
     GUIDED FORM NAVIGATION
     ════════════════════════════════════════════════════════ */
  /* ── Flow descriptors ─────────────────────────────────────
     The two guided flows, declared in one table so per-flow differences live
     here rather than scattered across call sites. Add per-flow differences as
     properties here, never as inline conditionals.

     scratch: full brief — references (required) → contact → budget → timeline.
     modify:  a shorter, lower-friction path. The base design already says what
              they want, so we capture contact first (so a drop-off is still a
              lead), then an OPTIONAL free-text "what to change" and an OPTIONAL
              timeline preference. No budget (the design is a price anchor) and
              no required references — both were where modify visitors bailed. */
  var FLOWS = {
    scratch: {
      keys: ['category', 'starter', 'refs', 'contact', 'budget', 'timeline']
    },
    modify: {
      keys: ['category', 'starter', 'contact', 'change', 'timeline-modify']
    }
  };

  /* The flow the current answers put us in: modify once one of our designs is
     chosen, scratch otherwise. Deep-link arrivals prefill into the modify flow;
     they are no longer a third order. */
  function currentFlow() {
    return (S.starter === 'modify' && S.baseDesign) ? FLOWS.modify : FLOWS.scratch;
  }

  /* Budget is only asked in flows whose keys include it (scratch). The modify
     flow skips it, so we must not report the default $ range as a real answer. */
  function budgetInFlow() { return currentFlow().keys.indexOf('budget') !== -1; }

  /* DOM step panes in current-flow order (panes are keyed, not positional). */
  function activeSteps() {
    var byKey = {};
    D.steps.forEach(function (el) { byKey[el.getAttribute('data-cd-step')] = el; });
    return currentFlow().keys.map(function (k) { return byKey[k]; }).filter(Boolean);
  }

  /* Re-point S.step at whichever pane is currently shown after the flow
     shape changes (e.g. the moment a base design is picked flips the order). */
  function syncStepIndex() {
    var list = activeSteps();
    var active = null;
    D.steps.forEach(function (el) { if (el.classList.contains('is-active')) active = el; });
    var i = active ? list.indexOf(active) : -1;
    S.step = i >= 0 ? i : Math.max(0, Math.min(S.step, list.length - 1));
  }

  function initGuidedForm() {
    if (!D.guidedWrap) return;
    renderStep();

    if (D.btnBack) D.btnBack.addEventListener('click', function () {
      if (S.step > 0) { S.step--; renderStep(); }
    });

    if (D.btnSkip) D.btnSkip.addEventListener('click', function () {
      if (currentStepKey() === 'budget') S.budgetSkipped = true;
      if (S.step < activeSteps().length - 1) { S.step++; renderStep(); }
    });

    if (D.btnNext) D.btnNext.addEventListener('click', function (e) {
      if (D.btnNext.disabled) { e.preventDefault(); return; }
      if (S.step < activeSteps().length - 1) {
        /* Advancing: renderStep() will flip this button to type="submit" when
           the next step is the last one. That type change happens DURING this
           click, so without preventDefault the browser would treat this very
           click as a submit and post the form on the way into the last step. */
        e.preventDefault();
        var leavingKey = currentStepKey();
        S.step++;
        renderStep();
        /* Passing the contact step = we have a real lead → "started" milestone */
        if (leavingKey === 'contact') fireStarted();
      }
      /* On the last step the button is already type="submit" and we don't
         preventDefault, so the native submit proceeds (keeps reCAPTCHA happy). */
    });
  }

  function renderStep() {
    var list  = activeSteps();
    var total = list.length;
    var step  = list[S.step];
    if (!step) return;

    /* Show/hide panes */
    D.steps.forEach(function (el) { el.classList.remove('is-active'); });
    step.classList.add('is-active');

    /* Progress bar */
    if (D.progressFill) D.progressFill.style.width = (((S.step + 1) / total) * 100) + '%';

    /* Back button */
    if (D.btnBack) D.btnBack.disabled = (S.step === 0);

    /* Skip / Continue / Submit labels */
    var isLast  = (S.step === total - 1);
    var stepKey = step.getAttribute('data-cd-step');

    /* References are always required now (data-required is fixed in the markup
       and the note is constant copy). The modify flow surfaces the hint as a
       prominent callout — a per-flow difference declared on the descriptor. */
    if (stepKey === 'refs') {
      var refsHint = qs('[data-refs-hint]', step);
      if (refsHint) refsHint.classList.toggle('cd-step__hint--guide', !!currentFlow().refsGuideHint);
      updateRefsIndicator();   /* seed the counter/outline on entering the step */
    }

    /* The modify flow's timeline offers a shorter set ("Our usual timeline" /
       "Expedited"). Normalise the stored value to one of them (default the
       usual) whenever the step shows, so the pre-selected pill and the brief
       stay in sync across every entry path (deep link, in-form, draft restore). */
    if (stepKey === 'timeline-modify') {
      if (S.timeline !== 'Our usual timeline' && S.timeline !== 'Expedited') {
        S.timeline = 'Our usual timeline';
      }
      qsa('[data-timeline]', step).forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-timeline') === S.timeline);
      });
    }

    var isRequired = step.getAttribute('data-required') === 'true';
    var isValid    = stepIsValid(S.step);

    if (D.btnSkip) D.btnSkip.style.display = (!isRequired && !isLast) ? '' : 'none';
    if (D.btnNext) {
      /* An image still uploading blocks send: Cloudinary hasn't returned a URL
         yet, so submitting now would email the brief with the image missing.
         Fold that into the same disabled state as step validity so the two
         can't disagree — they used to be set from two places that fought. */
      var uploading = uploadsInFlight > 0;
      D.btnNext.textContent = uploading ? 'Uploading images…'
                                        : (isLast ? 'Send your brief' : 'Continue →');
      D.btnNext.disabled    = uploading || (isRequired && !isValid);
      /* Swap from button to submit on last step */
      if (isLast) {
        D.btnNext.setAttribute('type', 'submit');
      } else {
        D.btnNext.setAttribute('type', 'button');
      }
    }

    /* Scroll top of form into view */
    var formTop = D.formSec || D.guidedWrap;
    if (formTop && S.step > 0) {
      var rect = formTop.getBoundingClientRect();
      if (rect.top < 0) { window.scrollTo({ top: window.scrollY + rect.top - 80, behavior: 'smooth' }); }
    }

    /* Persist progress */
    markChanged();
  }

  function stepIsValid(idx) {
    var stepEl = activeSteps()[idx];
    if (!stepEl) return true;
    var key = stepEl.getAttribute('data-cd-step');
    switch (key) {
      case 'category': return !!S.category;
      case 'starter':
        if (!S.starter) return false;
        if (S.starter === 'modify' && !S.baseDesign) return false;
        return true;
      case 'timeline': return !!S.timeline;
      case 'refs':
        return hasReference();
      case 'contact':
        return !!S.name && emailValid(S.email);
      default: return true;
    }
  }

  /* After any state change that affects Continue's disabled state */
  function refreshNav() {
    if (!D.btnNext) return;
    var cur        = activeSteps()[S.step];
    var isRequired = cur && cur.getAttribute('data-required') === 'true';
    var valid      = stepIsValid(S.step);
    /* Keep in lockstep with renderStep: a live upload disables send regardless
       of step validity. refreshNav fires from many spots (e.g. addFiles, right
       after an upload starts), so it must honour the upload state too — else it
       would re-enable the button mid-upload. */
    var uploading  = uploadsInFlight > 0;
    D.btnNext.disabled = uploading || (isRequired && !valid);
    if (uploading) D.btnNext.textContent = 'Uploading images…';
    updateRefsIndicator();
  }

  /* ── Reference requirement ──────────────────────────────
     Every brief needs something to work from — an image, a link, or a real
     description — in every flow, with no exemptions.
     Satisfied by an uploaded image, a usable link, or a REF_MIN_DESC+ char
     description. */
  var REF_MIN_DESC = 10;
  function hasReference() {
    return S.files.length > 0 || looksLikeUrl(S.refUrl) || S.notes.trim().length >= REF_MIN_DESC;
  }

  /* Show WHY the references step's Continue is disabled: outline the description
     box red and show a live character count until the step is satisfied (by an
     image, a link, or REF_MIN_DESC+ characters). Scratch-flow refs step only —
     the elements live only in that pane. */
  function updateRefsIndicator() {
    var refs = qs('[data-cd-step="refs"]', D.page);
    if (!refs) return;
    var met = hasReference();

    /* Description box: red outline + live character count until satisfied. */
    var counter  = qs('[data-refs-counter]', refs);
    var textarea = qs('[data-cd-field="notes"]', refs);
    if (counter && textarea) {
      var len = S.notes.trim().length;
      if (met) {
        textarea.classList.remove('cd-textarea--invalid');
        counter.classList.remove('is-warn');
        /* Confirm when they satisfied it by typing; stay quiet if via image/link. */
        counter.textContent = len >= REF_MIN_DESC ? (len + ' characters ✓') : '';
      } else {
        textarea.classList.add('cd-textarea--invalid');
        counter.classList.add('is-warn');
        counter.textContent = len + ' / ' + REF_MIN_DESC + ' characters (or add an image or link)';
      }
    }

    /* Link box: reassure that a bare domain gets https:// added, or flag an
       entry that isn't a link at all. */
    var linkInput = qs('[data-cd-field="ref-url"]', refs);
    var linkHint  = qs('[data-refurl-hint]', refs);
    if (linkInput && linkHint) {
      var raw = (S.refUrl || '').trim();
      if (!raw) {
        linkInput.classList.remove('cd-input--invalid');
        linkHint.classList.remove('is-warn');
        linkHint.textContent = '';
      } else if (looksLikeUrl(raw)) {
        linkInput.classList.remove('cd-input--invalid');
        linkHint.classList.remove('is-warn');
        /* Show what we'll actually use when the scheme was left off. */
        linkHint.textContent = /^https?:\/\//i.test(raw) ? '' : ("We'll use " + normalizeRefUrl(raw));
      } else {
        linkInput.classList.add('cd-input--invalid');
        linkHint.classList.add('is-warn');
        linkHint.textContent = 'Add the full address, e.g. pinterest.com/your-board';
      }
    }
  }

  /* The input is type="url", so the browser rejects a bare "pinterest.com/x".
     normalizeRefUrl adds the scheme on blur so people aren't blocked for it. */
  function validRefUrl(v) {
    return /^https?:\/\/[^\s.]+\.[^\s]{2,}/i.test((v || '').trim());
  }

  function normalizeRefUrl(v) {
    v = (v || '').trim();
    if (!v || /^https?:\/\//i.test(v)) return v;
    return /^[^\s.]+\.[^\s]{2,}/.test(v) ? 'https://' + v : v;
  }

  /* True if the input is a usable link OR a bare domain we'd auto-prefix with
     https:// (e.g. "google.com") — so a scheme-less domain counts as a valid
     reference live, not only after the blur fix-up. */
  function looksLikeUrl(v) {
    return validRefUrl(normalizeRefUrl(v));
  }

  /* Index of the first step that fails validation, or -1 if all pass.
     stepIsValid already returns true for optional steps, so any false here
     is a genuine blocker (e.g. "modify" with no base design, missing email). */
  function firstInvalidStep() {
    var list = activeSteps();
    for (var i = 0; i < list.length; i++) {
      if (!stepIsValid(i)) return i;
    }
    return -1;
  }

  /* First step in the current flow the visitor hasn't answered yet (else the
     first step). Used to drop a prefilled deep-link arrival on the right
     question rather than always at the top. */
  function firstUnansweredStep() {
    var bad = firstInvalidStep();
    return bad >= 0 ? bad : 0;
  }

  /* ════════════════════════════════════════════════════════
     CATEGORY CARDS
     ════════════════════════════════════════════════════════ */
  function updatePickerForCategory(catId) {
    qsa('[data-picker-for]', D.page).forEach(function (el) {
      el.style.display = el.getAttribute('data-picker-for') === catId ? '' : 'none';
    });
    setPickerNote(catId, false);

    /* Show the search box only when this category actually has designs */
    var hasItems = false;
    qsa('[data-picker-for="' + catId + '"]', D.page).forEach(function (el) {
      if (qs('.cd-picker-item', el)) hasItems = true;
    });
    qsa('[data-picker-search-row]', D.page).forEach(function (row) { row.hidden = !hasItems; });

    /* Reset any prior search text when switching category */
    qsa('[data-picker-search]', D.page).forEach(function (inp) { inp.value = ''; });

    ensurePickerLoaded(catId);
    applyPickerSearch();
  }

  function setPickerNote(catId, loading) {
    var noteEl = qs('[data-picker-note]', D.page);
    if (!noteEl) return;
    var base   = CAT_LABELS[catId] || catId;
    var scroll = qs('[data-picker-for="' + catId + '"]', D.page);
    var handle = scroll ? (scroll.getAttribute('data-collection-handle') || '') : '';
    if (handle) {
      /* A clear primary button to browse the full collection. New tab so the
         brief in progress isn't lost. */
      noteEl.innerHTML = '<a class="cd-btn cd-btn--primary cd-picker-collection-btn" href="/collections/' +
        encodeURIComponent(handle) + '" target="_blank" rel="noopener">View collection ↗</a>';
    } else {
      noteEl.textContent = loading ? base + ' · loading more…' : base;
    }
  }

  /* ── Lazy-load the 51+ overflow via the collection JSON endpoint ──
     Liquid renders the first 50; anything beyond that is fetched on
     demand the first time a category is opened, then cached in the DOM. */
  function ensurePickerLoaded(catId) {
    qsa('[data-picker-for="' + catId + '"]', D.page).forEach(function (scroll) {
      var handle = scroll.getAttribute('data-collection-handle');
      var count  = parseInt(scroll.getAttribute('data-collection-count'), 10) || 0;
      if (!handle || count <= 50) return;                 // nothing past the Liquid 50
      if (scroll.getAttribute('data-loaded') === 'true') return; // already fetched
      scroll.setAttribute('data-loaded', 'true');         // guard against double fetch
      loadPickerOverflow(scroll, handle, count, catId);
    });
  }

  function loadPickerOverflow(scroll, handle, count, catId) {
    var totalPages = Math.ceil(count / 50);
    setPickerNote(catId, true);

    /* Track handles already in the DOM so a sort-order overlap can't duplicate tiles */
    var seen = {};
    qsa('.cd-picker-item', scroll).forEach(function (b) {
      seen[b.getAttribute('data-design-id')] = true;
    });

    var page = 2; // page 1 == the Liquid-rendered 50
    function fetchNext() {
      if (page > totalPages) return done();
      fetch('/collections/' + handle + '/products.json?limit=50&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          var products = (data && data.products) || [];
          if (products.length) {
            var frag = document.createDocumentFragment();
            products.forEach(function (p) {
              if (seen[p.handle]) return;
              seen[p.handle] = true;
              frag.appendChild(buildPickerItem(p));
            });
            scroll.appendChild(frag);
          }
          page++;
          if (products.length < 50) { done(); } else { fetchNext(); }
        })
        .catch(function () { done(); });
    }
    function done() {
      setPickerNote(catId, false);
      reapplyBaseDesignSelection(); // mark a restored pick if it lived in the overflow
      applyPickerSearch();          // honor any text typed while loading
    }
    fetchNext();
  }

  function imgResize(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* Build a picker button from a products.json product (matches Liquid markup) */
  function buildPickerItem(p) {
    var btn = document.createElement('button');
    btn.className = 'cd-picker-item';
    btn.type = 'button';
    btn.setAttribute('data-design-id', p.handle);
    btn.setAttribute('data-design-name', p.title || '');
    btn.setAttribute('aria-label', 'Start from ' + (p.title || ''));

    var wrap = document.createElement('div');
    wrap.className = 'cd-picker-img-wrap';
    var src = (p.images && p.images[0]) ? imgResize(p.images[0].src, 400) : '';
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = p.title || '';
      img.className = 'cd-picker-img';
      img.loading = 'lazy';
      img.width = 400; img.height = 400;
      wrap.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.style.cssText = 'width:100%;height:100%;background:#f0ece4';
      wrap.appendChild(ph);
    }
    var name = document.createElement('div');
    name.className = 'cd-picker-name';
    name.textContent = p.title || '';

    btn.appendChild(wrap);
    btn.appendChild(name);
    return btn;
  }

  /* ── Title search — DOM filter over the visible scroll ── */
  function initPickerSearch() {
    qsa('[data-picker-search]', D.page).forEach(function (inp) {
      inp.addEventListener('input', applyPickerSearch);
    });
  }

  function applyPickerSearch() {
    qsa('[data-picker-search]', D.page).forEach(function (inp) {
      var q = (inp.value || '').trim().toLowerCase();
      var wrap = closestEl(inp, '.cd-picker-wrap') || D.page;
      qsa('.cd-picker-scroll', wrap).forEach(function (scroll) {
        if (scroll.style.display === 'none') return; // only the active category
        var anyShown = false;
        qsa('.cd-picker-item', scroll).forEach(function (item) {
          var name = (item.getAttribute('data-design-name') || '').toLowerCase();
          var match = !q || name.indexOf(q) !== -1;
          item.style.display = match ? '' : 'none';
          if (match) anyShown = true;
        });
        togglePickerNoResults(scroll, q !== '' && !anyShown);
      });
    });
  }

  function togglePickerNoResults(scroll, show) {
    var el = qs('.cd-picker-noresults', scroll);
    if (show) {
      if (!el) {
        el = document.createElement('p');
        el.className = 'cd-picker-empty cd-picker-noresults';
        el.textContent = 'No designs match that name.';
        scroll.appendChild(el);
      }
      el.style.display = '';
    } else if (el) {
      el.style.display = 'none';
    }
  }

  function reapplyBaseDesignSelection() {
    if (!S.baseDesign) return;
    qsa('[data-design-id]', D.page).forEach(function (b) {
      var sel = b.getAttribute('data-design-id') === S.baseDesign;
      b.classList.toggle('is-selected', sel);
      var nameEl = qs('.cd-picker-name', b);
      if (nameEl && sel && nameEl.textContent.indexOf(' ✓') === -1) {
        nameEl.textContent = (b.getAttribute('data-design-name') || '') + ' ✓';
      }
    });
  }

  /* "Modify one of your designs" only makes sense when the category has an
     actual product catalog to pick from — "Something Else" has none. */
  function updateStarterAvailability(catId) {
    var isOther = catId === 'other';
    qsa('[data-starter-id="modify"]', D.page).forEach(function (b) {
      b.style.display = isOther ? 'none' : '';
    });
    if (isOther && S.starter === 'modify') {
      S.starter = '';
      S.baseDesign = '';
      qsa('[data-starter-id]', D.page).forEach(function (b) {
        b.classList.remove('is-selected');
      });
      qsa('.cd-picker-wrap', D.page).forEach(function (el) {
        el.classList.remove('is-visible');
      });
      /* Clearing the modify starter reshapes the flow (modify → scratch) — keep
         the current pane's index aligned to the new key order, like the other
         reshape sites. */
      if (D.guidedWrap) syncStepIndex();
    }
  }

  function initCategoryCards() {
    qsa('[data-cat-id]', D.page).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-cat-id');
        S.category = id;
        qsa('[data-cat-id]', D.page).forEach(function (b) {
          b.classList.toggle('is-selected', b.getAttribute('data-cat-id') === S.category);
        });
        ensureSession();   /* first category pick starts the session record */
        updatePickerForCategory(id);
        updateStarterAvailability(id);
        updateSingleSummary();
        refreshNav();
        markChanged();
        /* Auto-advance to next step after a short visual moment */
        if (D.guidedWrap && currentStepKey() === 'category') {
          setTimeout(function () {
            /* Re-check at fire time — the user may have navigated during the
               delay. Advance only if still on this step, and never past the
               last (an overshoot would desync S.step from the rendered step
               and could leave the nav button as type=submit). */
            if (currentStepKey() === 'category' && S.step < activeSteps().length - 1) {
              S.step++; renderStep();
            }
          }, 260);
        }
      });
    });
  }

  function currentStepKey() {
    var el = activeSteps()[S.step];
    return el ? el.getAttribute('data-cd-step') : '';
  }

  /* ════════════════════════════════════════════════════════
     STARTER CARDS
     ════════════════════════════════════════════════════════ */
  function initStarterCards() {
    qsa('[data-starter-id]', D.page).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-starter-id');
        S.starter = id;
        qsa('[data-starter-id]', D.page).forEach(function (b) {
          b.classList.toggle('is-selected', b.getAttribute('data-starter-id') === id);
        });
        /* Show/hide design picker */
        qsa('.cd-picker-wrap', D.page).forEach(function (el) {
          el.classList.toggle('is-visible', id === 'modify');
        });
        if (id === 'modify' && S.category) updatePickerForCategory(S.category);
        /* Update refs step hint. The required flag itself is set in renderStep
           (the old [data-step-refs] selector here never matched anything). */
        qsa('[data-refs-hint]', D.page).forEach(function (el) {
          el.textContent = 'Please drop a description, a reference image or a link for the design or modification.';
        });
        /* Changing the starter can reshape the flow — realign S.step first */
        if (D.guidedWrap) syncStepIndex();
        refreshNav();
        markChanged();
        /* Auto-advance — but not when "modify" (the picker needs to stay visible) */
        if (id !== 'modify' && D.guidedWrap && currentStepKey() === 'starter') {
          setTimeout(function () {
            /* Re-check at fire time — see initCategoryCards for why. */
            if (currentStepKey() === 'starter' && S.step < activeSteps().length - 1) {
              S.step++; renderStep();
            }
          }, 260);
        }
      });
    });
  }

  /* ════════════════════════════════════════════════════════
     BUDGET SLIDER
     ════════════════════════════════════════════════════════ */
  var BUDGET_MIN = 800, BUDGET_MAX = 20000, BUDGET_STEP = 100;

  function initBudgetSlider() {
    var wrap = qs('[data-cd-slider="budget"]', D.page);
    if (!wrap) return;
    var inputMin    = qs('[data-slider-min]', wrap);
    var inputMax    = qs('[data-slider-max]', wrap);
    var fill        = qs('.cd-slider-fill', wrap);
    var readout     = qs('.cd-slider-readout__value', wrap);
    var helper      = qs('.cd-budget-helper', wrap);
    var unsureBtn   = qs('.cd-budget-unsure-btn', wrap);
    var trackWrap   = qs('.cd-slider-track-wrap', wrap);
    if (!inputMin || !inputMax) return;

    function updateBudget() {
      var lo = pct(S.budgetMin, BUDGET_MIN, BUDGET_MAX);
      var hi = pct(S.budgetMax, BUDGET_MIN, BUDGET_MAX);
      if (fill) { fill.style.left = lo + '%'; fill.style.width = (hi - lo) + '%'; }
      if (readout) {
        readout.textContent = S.budgetUnsure ? 'Not sure yet'
          : fmtDollar(S.budgetMin) + ' – ' + fmtDollar(S.budgetMax) + (S.budgetMax >= BUDGET_MAX ? '+' : '');
      }
      if (helper) {
        helper.textContent = S.budgetUnsure
          ? "No problem — we'll narrow it down together on the call."
          : 'Typically ~30% less than comparable retail.';
      }
      if (unsureBtn) unsureBtn.classList.toggle('is-active', S.budgetUnsure);
      if (trackWrap) trackWrap.classList.toggle('is-muted', S.budgetUnsure);
      updateSingleSummary();
    }

    inputMin.addEventListener('input', function () {
      S.budgetMin = clamp(parseInt(this.value, 10), BUDGET_MIN, S.budgetMax - BUDGET_STEP);
      S.budgetUnsure = false;
      this.value = S.budgetMin;
      updateBudget();
      markChanged();
    });
    inputMax.addEventListener('input', function () {
      S.budgetMax = clamp(parseInt(this.value, 10), S.budgetMin + BUDGET_STEP, BUDGET_MAX);
      S.budgetUnsure = false;
      this.value = S.budgetMax;
      updateBudget();
      markChanged();
    });
    if (unsureBtn) unsureBtn.addEventListener('click', function () {
      S.budgetUnsure = !S.budgetUnsure;
      updateBudget();
      refreshNav();
      markChanged();
    });

    /* Expose for autosave restore */
    D.budgetInputs = { min: inputMin, max: inputMax };
    D.updateBudget = updateBudget;

    updateBudget();
  }

  /* ════════════════════════════════════════════════════════
     TIMELINE PILLS
     ════════════════════════════════════════════════════════ */
  function initTimelinePills() {
    qsa('[data-timeline]', D.page).forEach(function (btn) {
      btn.addEventListener('click', function () {
        S.timeline = btn.getAttribute('data-timeline');
        qsa('[data-timeline]', D.page).forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-timeline') === S.timeline);
        });
        updateSingleSummary();
        refreshNav();
        markChanged();
      });
      /* Pre-select default */
      if (btn.getAttribute('data-timeline') === S.timeline) btn.classList.add('is-active');
    });
  }

  /* ════════════════════════════════════════════════════════
     NOTES / CONTACT FIELDS
     ════════════════════════════════════════════════════════ */
  function initContactFields() {
    /* Bind ALL matching fields, not just the first: "notes" appears both in the
       references step (scratch) and the "what to change" step (modify), and both
       must sync S.notes. */
    function bind(sel, key) {
      qsa(sel, D.page).forEach(function (el) {
        el.addEventListener('input', function () {
          S[key] = this.value; updateSingleSummary(); refreshNav(); markChanged();
          /* Fire the "started" milestone as soon as contact is validly filled, in
             every flow — this captures a visitor who completes contact and then
             abandons on that step. Idempotent (startedFired guard) and gated on a
             valid name + email, so the overlap with the advance-past-contact
             trigger is harmless. */
          if (key === 'name' || key === 'email') fireStarted();
        });
      });
    }
    bind('[data-cd-field="name"]',    'name');
    bind('[data-cd-field="email"]',   'email');
    bind('[data-cd-field="phone"]',   'phone');
    bind('[data-cd-field="notes"]',   'notes');
    bind('[data-cd-field="ref-url"]', 'refUrl');

    /* Add the missing scheme on blur ("pinterest.com/x" → "https://pinterest.com/x")
       so the type="url" input doesn't reject an otherwise fine link. */
    qsa('[data-cd-field="ref-url"]', D.page).forEach(function (el) {
      el.addEventListener('blur', function () {
        var fixed = normalizeRefUrl(this.value);
        if (fixed !== this.value) {
          this.value = fixed;
          S.refUrl = fixed;
          refreshNav();
          markChanged();
        }
      });
    });
  }

  /* ════════════════════════════════════════════════════════
     REFERENCE DROPZONE
     ════════════════════════════════════════════════════════ */
  function initDropzone() {
    var zone    = qs('.cd-dropzone', D.page);
    var input   = zone ? qs('input[type="file"]', zone) : null;
    var preview = qs('.cd-file-previews', D.page);
    if (!zone || !input) return;

    var MAX_BYTES = 10 * 1024 * 1024; /* 10 MB */

    function showDropError(msg) {
      var note = qs('.cd-dropzone-error', D.page);
      if (!note) {
        note = document.createElement('p');
        note.className = 'cd-dropzone-error';
        note.setAttribute('role', 'alert');
        zone.parentNode.insertBefore(note, zone.nextSibling);
      }
      note.textContent = msg;
      note.style.display = msg ? '' : 'none';
    }

    function addFiles(fileList) {
      var rejected = [];
      Array.prototype.slice.call(fileList).forEach(function (f) {
        if (S.files.length >= 6) { rejected.push(f.name + ' (max 6 images)'); return; }
        if (f.type.indexOf('image/') !== 0) { rejected.push(f.name + ' (not an image)'); return; }
        if (f.size > MAX_BYTES) { rejected.push(f.name + ' (over 10 MB)'); return; }
        var item = { name: f.name, objectUrl: URL.createObjectURL(f), file: f };
        S.files.push(item);
        startUpload(item); /* upload in the background right away */
      });
      showDropError(rejected.length ? 'Skipped: ' + rejected.join(', ') : '');
      renderPreviews();
      refreshNav();
      markChanged();
    }

    function renderPreviews() {
      if (!preview) return;
      preview.innerHTML = '';
      S.files.forEach(function (f, i) {
        var div = document.createElement('div');
        div.className = 'cd-file-thumb';
        if (f.objectUrl) {
          var img = document.createElement('img');
          img.src = f.objectUrl;
          img.alt = f.name;
          div.appendChild(img);
        } else {
          var name = document.createElement('div');
          name.className = 'cd-file-thumb__name';
          name.textContent = f.name;
          div.appendChild(name);
        }
        var rm = document.createElement('button');
        rm.className = 'cd-file-thumb__remove';
        rm.type = 'button';
        rm.textContent = '×';
        rm.setAttribute('aria-label', 'Remove ' + f.name);
        rm.addEventListener('click', function (e) {
          e.stopPropagation();
          S.files.splice(i, 1);
          renderPreviews();
          refreshNav();
          markChanged();
        });
        div.appendChild(rm);
        preview.appendChild(div);
      });
    }

    zone.addEventListener('click', function () { input.click(); });
    input.addEventListener('change', function () { addFiles(this.files); this.value = ''; });
    zone.addEventListener('dragover', function (e) { e.preventDefault(); zone.classList.add('is-drag-over'); });
    zone.addEventListener('dragleave', function ()  { zone.classList.remove('is-drag-over'); });
    zone.addEventListener('drop', function (e) {
      e.preventDefault();
      zone.classList.remove('is-drag-over');
      addFiles(e.dataTransfer.files);
    });
  }

  /* ════════════════════════════════════════════════════════
     SINGLE-PAGE SIDEBAR LIVE SUMMARY
     ════════════════════════════════════════════════════════ */
  function updateSingleSummary() {
    var container = qs('.cd-brief-card', D.page);
    if (!container) return;
    var items = buildSummaryItems();
    var listEl = qs('[data-cd-brief-list]', container);
    var emptyEl = qs('[data-cd-brief-empty]', container);
    if (!listEl) return;
    listEl.innerHTML = '';
    if (items.length === 0) {
      if (emptyEl) emptyEl.style.display = '';
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      items.forEach(function (text) {
        var row = document.createElement('div');
        row.className = 'cd-brief-item';
        row.innerHTML = '<span class="cd-brief-item__bullet">◆</span><span class="cd-brief-item__text">' + escHtml(text) + '</span>';
        listEl.appendChild(row);
      });
    }
  }

  function buildSummaryItems() {
    var items = [];
    if (S.category) items.push(categoryLabel(S.category));
    if (S.starter === 'modify' && S.baseDesign) items.push('Based on: ' + S.baseDesign);
    if (budgetInFlow()) items.push(S.budgetUnsure ? 'Budget: flexible' : fmtDollar(S.budgetMin) + ' – ' + fmtDollar(S.budgetMax));
    if (S.timeline) items.push(S.timeline);
    return items;
  }

  function categoryLabel(id) {
    var map = { engagement: 'Engagement Ring', wedding: 'Wedding Band', 'wedding-male': "Men's Band",
                necklace: 'Necklace', earrings: 'Earrings', bracelet: 'Bracelet', other: 'Something Else' };
    return map[id] || id;
  }

  function escHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function initSinglePageSidebar() {
    updateSingleSummary();
  }

  /* ════════════════════════════════════════════════════════
     FORM COMPILATION + SUBMIT
     ════════════════════════════════════════════════════════ */
  /* Single source of truth for the brief text — used by both the form
     body (email) and the WhatsApp message. */
  function buildBriefText() {
    var uploaded = S.files.filter(function (f) { return f.url; }).map(function (f) { return f.url; });
    var imagesLine;
    if (uploaded.length) {
      imagesLine = 'Reference images:\n  ' + uploaded.join('\n  ');
    } else if (S.files.length) {
      /* Upload not configured or failed — at least record the file names */
      imagesLine = 'Reference images: ' + S.files.map(function (f) { return f.name; }).join(', ') + ' (uploaded by customer — not delivered)';
    } else {
      imagesLine = 'Reference images: None';
    }
    var lines = [
      'Category: '      + (categoryLabel(S.category) || 'Not specified'),
      'Starter: '       + (S.starter || 'Not specified'),
      'Base design: '   + (S.baseDesign || 'None'),
      'Budget: '        + (!budgetInFlow() ? 'Not specified' : (S.budgetUnsure ? 'Not sure' : fmtDollar(S.budgetMin) + ' – ' + fmtDollar(S.budgetMax))),
      'Timeline: '      + (S.timeline || 'Not specified'),
      'Reference link: '+ (normalizeRefUrl(S.refUrl) || 'None'),
      imagesLine,
      'Notes: '         + (S.notes.trim() || 'None')
    ];
    return lines.join('\n');
  }

  function compileBody() {
    if (D.hiddenBody) D.hiddenBody.value = buildBriefText();
  }

  /* ── WhatsApp helpers ─────────────────────────────────── */
  function whatsappNumber() {
    var el = qs('[data-cd-whatsapp]', D.page);
    var raw = el ? el.getAttribute('data-cd-whatsapp') : '';
    return (raw || '').replace(/[^0-9]/g, '');   /* wa.me wants digits only, incl. country code */
  }

  /* Build a customer-facing WhatsApp message (their own brief, first-person). */
  function whatsappMessage() {
    var name = (S.name || '').split(' ')[0];
    var intro = name
      ? 'Hi, this is ' + name + " — here's my custom design brief:"
      : "Hi — here's my custom design brief:";
    return intro + '\n\n' + buildBriefText();
  }

  function whatsappUrl(message) {
    var num = whatsappNumber();
    if (!num) return '';
    var base = 'https://wa.me/' + num;
    return message ? base + '?text=' + encodeURIComponent(message) : base;
  }

  /* ── Cloudinary unsigned upload ──────────────────────────
     Shopify's contact form can't carry attachments, so we host
     the images on Cloudinary first and email the links. */
  function cloudinaryConfig() {
    var cfg = qs('[data-cd-cloudinary]', D.page);
    if (!cfg) return null;
    var cloud  = cfg.getAttribute('data-cloud');
    var preset = cfg.getAttribute('data-preset');
    if (!cloud || !preset) return null;
    return { cloud: cloud, preset: preset };
  }

  /* Upload one image as soon as it's added, in the background, so the
     final form submit stays a normal user click that Shopify's bot
     protection (invisible reCAPTCHA) can verify. */
  var uploadsInFlight = 0;

  function startUpload(item) {
    var cfg = cloudinaryConfig();
    if (!cfg || !item.file || item.url) return; /* not configured, or already done */
    item.uploading = true;
    uploadsInFlight++;
    updateUploadGate();

    /* Bound the wait. Now that an in-flight upload genuinely blocks submit, a
       hung request would trap the customer on a disabled button forever — so
       abort after 30s and fall back to the filename record. */
    var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, 30000);

    var fd = new FormData();
    fd.append('file', item.file);
    fd.append('upload_preset', cfg.preset);
    fetch('https://api.cloudinary.com/v1_1/' + cfg.cloud + '/auto/upload',
          { method: 'POST', body: fd, signal: controller ? controller.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && d.secure_url) item.url = d.secure_url; })
      .catch(function () { /* aborted or failed — leave item.url unset, filename fallback */ })
      .then(function () {
        clearTimeout(timer);
        item.uploading = false;
        uploadsInFlight--;
        updateUploadGate();
      });
  }

  /* Re-derive whether the brief can be sent whenever an upload starts or ends.
     The submit control differs by layout, so route to the one place that owns
     each: guided uses the shared nav button (refreshNav folds in the upload
     state), single-page has its own dedicated submit button.

     The old version targeted qs('[type="submit"]') on the contact form, but in
     the guided flow that button only exists on the last step, so a mid-flow
     upload found nothing to gate — and even on the last step a following
     refreshNav re-enabled it. Both holes are closed now. */
  function updateUploadGate() {
    if (D.guidedWrap) {
      refreshNav();                 /* folds uploadsInFlight into disabled + label */
      if (uploadsInFlight === 0 && D.btnNext) {
        /* Restore the label refreshNav leaves untouched when idle. */
        var isLast = (S.step === activeSteps().length - 1);
        D.btnNext.textContent = isLast ? 'Send your brief' : 'Continue →';
      }
      return;
    }
    var btn = qs('[type="submit"]', D.contactForm);   /* single-page layout */
    if (!btn) return;
    btn.disabled    = uploadsInFlight > 0;
    btn.textContent = uploadsInFlight > 0 ? 'Uploading images…' : 'Send your brief';
  }

  var submitted = false;   /* guards against double-submit (repeated clicks) */

  function initFormSubmit() {
    var form = D.contactForm;
    if (!form) return;

    /* Enter inside a field must never submit the multi-step brief. Pressing
       Enter in a text-type input triggers implicit form submission, which would
       post the brief mid-flow (landing on the success page). The only intended
       way to submit is a real click on the final-step Send button. Capture phase
       + preventDefault stops it before any implicit submit; buttons still act on
       Enter (Continue / Send / cards) and textareas keep their newlines. */
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.keyCode !== 13) return;
      var tag = e.target && e.target.tagName;
      if (tag === 'TEXTAREA' || tag === 'BUTTON' || tag === 'A' || tag === 'SELECT') return;
      e.preventDefault();
    }, true);

    /* Plain synchronous submit — images are already uploaded by now,
       and we don't touch the event, so reCAPTCHA proceeds normally. */
    form.addEventListener('submit', function (e) {
      /* Block repeat submits — Shopify's POST + reCAPTCHA takes a beat, and an
         impatient double/triple-click would otherwise fire a brief each time. */
      if (submitted) { e.preventDefault(); return; }

      /* Never post while an image is still uploading — Cloudinary hasn't
         returned a URL yet, so the email would go out with the image missing.
         Blocking here (before the Telegram/Sheet beacon below) also keeps the
         two notification paths in sync: previously a mid-upload submit fired
         the beacon but Shopify could drop the email, so you'd get a Telegram
         ping with no matching email. */
      if (uploadsInFlight > 0) {
        e.preventDefault();
        updateUploadGate();     /* re-assert the disabled 'Uploading images…' state */
        return;
      }

      /* Authoritative final gate — never trust the step UI alone. Blocks a
         submit (from any source: Enter key, a stale button, etc.) if a
         required step is unmet. */
      if (D.guidedWrap) {
        /* Only the final step may submit. A submit fired from any earlier step
           — a stray Enter, the nav button left as type=submit by an
           auto-advance that fired after the user navigated, an overshot step
           index — is accidental. This is the critical guard: once every step
           is valid (exactly the state after you reach the end and step back),
           firstInvalidStep() below returns -1, so WITHOUT this check any stray
           submit trigger would silently post the brief. */
        var lastIdx = activeSteps().length - 1;
        if (S.step !== lastIdx) {
          e.preventDefault();
          S.step = clamp(S.step, 0, lastIdx);   /* recover from an overshoot */
          renderStep();                          /* re-sync UI + restore button type */
          return;
        }
        var bad = firstInvalidStep();
        if (bad >= 0) {
          e.preventDefault();
          S.step = bad;
          renderStep();          /* jump the customer to the step they missed */
          if (activeSteps()[bad].getAttribute('data-cd-step') === 'starter' && S.starter === 'modify' && !S.baseDesign) {
            qsa('.cd-picker-wrap', D.page).forEach(function (el) { el.classList.add('is-invalid'); });
          }
          return;
        }
      } else if (S.starter === 'modify' && !S.baseDesign) {
        /* Single-page layout has no per-step gate, so enforce it here. */
        e.preventDefault();
        qsa('.cd-picker-wrap', D.page).forEach(function (el) {
          el.classList.add('is-invalid');
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        return;
      }
      /* Valid submit — latch it so any further clicks are ignored, and cancel
         a pending progress beacon so it can't race the submission. */
      submitted = true;
      if (progressTimer) { clearTimeout(progressTimer); progressTimer = null; }

      compileBody();
      /* Final milestone → upsert the session as submitted (Sheet + Telegram +
         Klaviyo, server-side). ensureSession covers a single-page submit that
         never picked a category through the guided flow. */
      ensureSession();
      advanceStage('submitted');
      sendEvent('submitted');
      /* Stash the brief so the success screen (a fresh page load) can offer
         a pre-filled WhatsApp chat. Survives clearBrief; consumed on read. */
      try { localStorage.setItem(LS_MSG_KEY, whatsappMessage()); } catch (e2) {}

      /* Feedback so the customer doesn't re-click while the POST is in flight.
         Deferred to a timeout so disabling the button can't cancel THIS native
         submit that's already underway. */
      var subBtn = e.submitter || qs('[type="submit"]', form);
      if (subBtn) {
        setTimeout(function () { subBtn.disabled = true; subBtn.textContent = 'Sending…'; }, 0);
      }
    });
  }

  /* "Start a chat right away" buttons alongside the form (pre-submit).
     Opens WhatsApp with whatever the customer has filled in so far. */
  function initWhatsAppChatButtons() {
    var num = whatsappNumber();
    qsa('[data-cd-wa-chat]', D.page).forEach(function (btn) {
      if (!num) {
        /* Hide the button and, for the guided inline prompt, its whole row */
        (closestEl(btn, '.cd-wa-inline') || btn).style.display = 'none';
        return;
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = whatsappUrl(whatsappMessage());
        if (url) window.open(url, '_blank', 'noopener');
      });
    });
  }

  /* ════════════════════════════════════════════════════════
     PROCESS TIMELINE — mobile carousel + step modal
     ════════════════════════════════════════════════════════ */
  function initProcessTimeline() {
    qsa('.cd-process-track', D.page).forEach(function (track) {
      var steps   = qsa('.cd-process-step', track);
      var dotsWrap = track.parentNode.querySelector('.cd-swipe-dots');
      var activeDot = 0;

      /* Build dots */
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        steps.forEach(function (_, i) {
          var btn = document.createElement('button');
          btn.className = 'cd-swipe-dot' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Go to step ' + (i + 1));
          btn.style.width = (i === 0 ? '18px' : '7px');
          btn.addEventListener('click', function () { scrollToStep(i); });
          dotsWrap.appendChild(btn);
        });
      }

      /* Scroll sync */
      track.addEventListener('scroll', function () {
        var nearest = nearestCard(track);
        if (nearest !== activeDot) {
          activeDot = nearest;
          updateDots(dotsWrap, activeDot, track.closest('.cd-process-sec--dark') !== null);
        }
      }, { passive: true });

      function scrollToStep(i) {
        var card = steps[i];
        if (!card) return;
        var delta = card.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({ left: track.scrollLeft + delta - 20, behavior: 'smooth' });
      }

      /* Step modal — any screen size */
      steps.forEach(function (stepEl, i) {
        stepEl.addEventListener('click', function () {
          openProcessModal(stepEl, i, steps);
        });
      });
    });
  }

  function nearestCard(track) {
    var cards   = qsa('.cd-process-step', track);
    var center  = track.getBoundingClientRect().left + track.offsetWidth / 2;
    var best = 0, bestDist = Infinity;
    cards.forEach(function (c, i) {
      var r = c.getBoundingClientRect();
      var d = Math.abs((r.left + r.width / 2) - center);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  function updateDots(wrap, active, isDark) {
    if (!wrap) return;
    var dots = qsa('.cd-swipe-dot', wrap);
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === active);
      d.style.width = (i === active ? '18px' : '7px');
    });
  }

  function openProcessModal(stepEl, idx, allSteps) {
    var backdrop = qs('#cd-process-modal', D.page);
    if (!backdrop) return;
    setProcessModalContent(backdrop, stepEl, idx, allSteps);
    backdrop.classList.add('is-open');
    document.body.classList.add('cd-modal-open');
  }

  function setProcessModalContent(backdrop, stepEl, idx, allSteps) {
    var num   = stepEl.querySelector('.cd-process-step__num');
    var tag   = stepEl.querySelector('.cd-process-step__tag');
    var title = stepEl.querySelector('.cd-process-step__title');
    var more  = stepEl.getAttribute('data-more');

    var elNum   = qs('[data-modal-num]',   backdrop);
    var elTag   = qs('[data-modal-tag]',   backdrop);
    var elTitle = qs('[data-modal-title]', backdrop);
    var elBody  = qs('[data-modal-body]',  backdrop);
    if (elNum)   elNum.textContent   = num   ? num.textContent   : '';
    if (elTag)   elTag.textContent   = tag   ? tag.textContent   : '';
    if (elTitle) elTitle.textContent = title ? title.textContent : '';
    if (elBody)  elBody.textContent  = more  || '';

    /* Dot nav */
    var dotsEl = qs('[data-modal-dots]', backdrop);
    if (dotsEl) {
      dotsEl.innerHTML = '';
      allSteps.forEach(function (_, j) {
        var btn = document.createElement('button');
        btn.className = 'cd-modal__dot' + (j === idx ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Step ' + (j + 1));
        btn.addEventListener('click', function () {
          setProcessModalContent(backdrop, allSteps[j], j, allSteps);
        });
        dotsEl.appendChild(btn);
      });
    }
  }

  /* ════════════════════════════════════════════════════════
     GALLERY LIGHTBOX
     ════════════════════════════════════════════════════════ */
  function initGallery() {
    var figures  = qsa('.cd-gallery-figure', D.page);
    var backdrop = qs('#cd-gallery-modal', D.page);
    if (!backdrop || !figures.length) return;
    var activeIdx = 0;

    figures.forEach(function (fig, i) {
      fig.addEventListener('click', function () { open(i); });
    });

    function open(i) {
      activeIdx = i;
      render();
      backdrop.classList.add('is-open');
      document.body.classList.add('cd-modal-open');
    }

    function render() {
      var fig     = figures[activeIdx];
      var img     = qs('img', fig);
      var cap     = qs('.cd-gallery-figcap', fig);
      var stone   = fig.getAttribute('data-stone')  || '';
      var metal   = fig.getAttribute('data-metal')  || '';
      var story   = fig.getAttribute('data-story')  || '';
      var baseLnk = (fig.getAttribute('data-base-link') || '').trim();

      var lbImg   = qs('.cd-lightbox__img', backdrop);
      var lbTitle = qs('.cd-lightbox__title', backdrop);
      var lbStone = qs('[data-lb-stone]', backdrop);
      var lbMetal = qs('[data-lb-metal]', backdrop);
      var lbStory = qs('.cd-lightbox__story', backdrop);
      var lbBase  = qs('[data-lb-baselink]', backdrop);
      var counter = qs('.cd-lightbox__counter', backdrop);

      if (lbImg && img)   { lbImg.src = img.src; lbImg.alt = img.alt || ''; }
      if (lbTitle && cap) lbTitle.textContent = cap.textContent;
      if (lbStone)        lbStone.textContent = stone;
      if (lbMetal)        lbMetal.textContent = metal;
      if (lbStory)        lbStory.textContent = story;
      if (lbBase) {
        /* Only show the base-design link when this piece has one. */
        if (baseLnk) { lbBase.href = baseLnk; lbBase.hidden = false; }
        else { lbBase.hidden = true; lbBase.removeAttribute('href'); }
      }
      if (counter)        counter.textContent = (activeIdx + 1) + ' / ' + figures.length;
    }

    qs('[data-lb-prev]', backdrop) && qs('[data-lb-prev]', backdrop).addEventListener('click', function () {
      activeIdx = (activeIdx - 1 + figures.length) % figures.length;
      render();
    });
    qs('[data-lb-next]', backdrop) && qs('[data-lb-next]', backdrop).addEventListener('click', function () {
      activeIdx = (activeIdx + 1) % figures.length;
      render();
    });

    /* Close */
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) closeModal(backdrop);
    });
    qs('.cd-lightbox__close', backdrop) && qs('.cd-lightbox__close', backdrop).addEventListener('click', function () {
      closeModal(backdrop);
    });
  }

  /* ════════════════════════════════════════════════════════
     CLOSE ANY MODAL
     ════════════════════════════════════════════════════════ */
  function closeModal(backdrop) {
    backdrop.classList.remove('is-open');
    document.body.classList.remove('cd-modal-open');
  }

  /* Wire up global modal close buttons and backdrops */
  document.addEventListener('DOMContentLoaded', function () {
    qsa('[data-cd-modal-close]', document).forEach(function (btn) {
      var target = qs(btn.getAttribute('data-cd-modal-close'));
      if (target) btn.addEventListener('click', function () { closeModal(target); });
    });
    qsa('.cd-modal-backdrop:not(.cd-lightbox-backdrop)', document).forEach(function (bd) {
      bd.addEventListener('click', function (e) {
        if (e.target === bd) closeModal(bd);
      });
    });
  });

  /* Esc key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      qsa('.cd-modal-backdrop.is-open', document).forEach(function (bd) { closeModal(bd); });
    }
  });

  /* ════════════════════════════════════════════════════════
     FAQ ACCORDION
     ════════════════════════════════════════════════════════ */
  function initFAQ() {
    qsa('.cd-accordion', D.page).forEach(function (item) {
      var trigger = qs('.cd-accordion__trigger', item);
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        /* Close all */
        qsa('.cd-accordion', D.page).forEach(function (i) { i.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ── Design picker init (called after DOM ready) ────── */
  function initDesignPickerActual() {
    /* Delegated so JSON-fetched (51+) buttons are clickable too */
    D.page.addEventListener('click', function (e) {
      var btn = closestEl(e.target, '[data-design-id]');
      if (!btn || !D.page.contains(btn)) return;
      var id = btn.getAttribute('data-design-id');
      S.baseDesign = (S.baseDesign === id) ? '' : id;
      qsa('[data-design-id]', D.page).forEach(function (b) {
        var isSelected = S.baseDesign !== '' && b.getAttribute('data-design-id') === S.baseDesign;
        b.classList.toggle('is-selected', isSelected);
        var nameEl = qs('.cd-picker-name', b);
        if (nameEl) {
          var baseName = b.getAttribute('data-design-name') || '';
          nameEl.textContent = baseName + (isSelected ? ' ✓' : '');
        }
      });
      qsa('.cd-picker-wrap', D.page).forEach(function (el) { el.classList.remove('is-invalid'); });
      updateSingleSummary();
      /* Picking/clearing a base design flips the modify flow on/off — keep the
         current pane's index aligned to the new step order. */
      if (D.guidedWrap) syncStepIndex();
      refreshNav();
      markChanged();
    });
  }

  /* ── Boot ────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
